export default __webpack_public_path__ + "static/media/attorney_3_small.8d1699d4.png";